import React from 'react';
import { useLanguage } from '../i18n/LanguageProvider';
import { Listbox, ListboxButton, ListboxOptions } from '@headlessui/react';

// Simple inline SVG icons
// Replace HR inline SVG with image from public/hr.svg
const HrFlagImg: React.FC<{ className?: string }> = ({ className = 'h-4 w-6 rounded-[2px] ring-1 ring-gray-300 overflow-hidden object-cover' }) => (
  <img src="/hr.svg" alt="" aria-hidden="true" className={className} />
);

// NEW: US flag image from public/us.svg for EN
const UsFlagImg: React.FC<{ className?: string }> = ({ className = 'h-4 w-6 rounded-[2px] ring-1 ring-gray-300 overflow-hidden object-cover' }) => (
  <img src="/us.svg" alt="" aria-hidden="true" className={className} />
);

const PortalHeader: React.FC = () => {
  const { lang, setLang, t } = useLanguage();

  const options: { value: 'hr' | 'en'; label: string; icon: JSX.Element }[] = [
    { value: 'hr', label: 'Croatian', icon: <HrFlagImg /> },
    { value: 'en', label: 'English', icon: <UsFlagImg /> },
  ];
  const current = options.find((o) => o.value === lang);

  return (
    <div className="pp-hdr-wrap">
      <div className="pp-hdr-left">
        <img src="/favicon.ico" alt="App icon" className="pp-hdr-icon" />
        <div className="pp-hdr-title" title={t('welcomeMessage')}>
          {t('welcomeMessage')}
        </div>
      </div>

      <div className="relative inline-block shrink-0">
        <Listbox value={lang} onChange={(v) => setLang(v as 'hr' | 'en')}>
          <ListboxButton className="pp-lb-compact-btn" aria-label="Select language">
            <span aria-hidden="true" className="inline-flex items-center">{options.find(o => o.value === lang)?.icon}</span>
            <span className="sr-only">{options.find(o => o.value === lang)?.label}</span>
            <span aria-hidden="true"> ▾</span>
          </ListboxButton>
          <ListboxOptions className="pp-lb-compact-panel">
            {options.map((opt) => (
              <Listbox.Option key={opt.value} value={opt.value}>
                {({ active, selected }: { active: boolean; selected: boolean }) => (
                  <div
                    className={`pp-lb-compact-item ${active ? 'pp-lb-item--active' : ''} ${selected ? 'pp-lb-item--selected' : ''} flex items-center gap-2`}
                  >
                    <span aria-hidden="true">{opt.icon}</span>
                    <span className="sr-only">{opt.label}</span>
                  </div>
                )}
              </Listbox.Option>
            ))}
          </ListboxOptions>
        </Listbox>
      </div>
    </div>
  );
};

export default PortalHeader;
